import { IGetConsolidatedActivitySalesReport, IGetCustomerActivitySalesReport, IGetLeadActivitySalesReport, IGetUserActivitySalesReport } from "../../../../types/sales/reportInterface";
import api from "../../../../lib/api";

export const getUserActivitySalesReportApi = async (data: IGetUserActivitySalesReport) => {
  return await api.post(`/sales/reports/activity/user-wise`, data);
};

export const getLeadActivitySalesReportApi = async (data: IGetLeadActivitySalesReport) => {
  return await api.post(`/sales/reports/activity/lead-wise`, data);
};

export const getCustomerActivitySalesReportApi = async (data: IGetCustomerActivitySalesReport) => {
  return await api.post(`/sales/reports/activity/customer-wise`, data);
};

export const getConsolidatedActivitySalesReportApi = async (data: IGetConsolidatedActivitySalesReport) => {
  return await api.post(`/sales/reports/activity/consolidate-report`, data);
};
